module.exports = __webpack_public_path__ + "static/media/user-instagram.18039bcb.svg";